import { faSearch, faTimes } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import VisibilityIcon from '@mui/icons-material/Visibility'
import { Box, Grid, IconButton, InputAdornment } from "@mui/material"
import InstallmentApi, { FindAllInstallment } from "api/finances/installment.api"
import Loading from "component/Loading"
import TableCustom from "component/Table/TableCustom"
import TableRowCommon from "component/Table/TableRowCommon"
import { colors } from "constants/theme"
import _ from "lodash"
import moment from "moment"
import MainButton from "new-components/buttons/main-button"
import DateRangeInput from "new-components/inputs/date-range-input"
import TextInput from "new-components/inputs/text-input"
import { useEffect, useState } from "react"
import { useTranslation } from "react-i18next"
import { useHistory } from "react-router-dom"
import { routeName } from "routes/routes-name"
import { numberFormat } from "utils/app.utils"
import { dateToView } from "utils/date.utils"

const Installment = () => {
    const { t } = useTranslation()

    const [loading, setLoading] = useState(true)
    const history = useHistory()

    const [page, setPage] = useState(1)
    const [pageLimit, setPageLimit] = useState(10)
    const [rowCount, setRowCount] = useState(0)
    const [sortBy, setSortBy] = useState('createAt')
    const [sortType, setSortType] = useState('DESC')
    const [search, setSearch] = useState('')
    const [rangeDate, setRangeDate] = useState(['', ''])

    const [dataInstallment, setDataInstallment] = useState<any>([])

    const loadDataInstallment = async () => {
        setLoading(true)
        const condition: FindAllInstallment = {
            page: page,
            pageLimit: pageLimit,
            sortBy: sortBy,
            sortType: sortType,
            search: search,
            dateStart: rangeDate[0] || '',
            dateEnd: rangeDate[1] || ''
        }
        await InstallmentApi.findAll(condition).then((res: any) => {
            if (res?.data) {
                setDataInstallment((prev: any) => (res.data))
                setRowCount(Number(res?.headers?.['x-total'] || 0))
            }
        }).finally(() => setLoading(false))
    }

    useEffect(() => {
        loadDataInstallment()
    }, [page, pageLimit])

    const onViewInstallment = (id: number) => {
        history.push(`${routeName.installment}/${id}`)
    }

    const headCells = [
        { id: 'no', disablePadding: false, label: t('INSTALLMENT.TABLE.NUMBER'), width: '50px', align: 'center', class: 'text-nowrap ' },
        { id: 'cnNumber', disablePadding: false, label: t('INSTALLMENT.TABLE.CNNUMBER'), align: 'center', width: '140px', class: 'text-nowrap ' },
        { id: 'branchCnNumber', disablePadding: false, label: t('INSTALLMENT.TABLE.BRANCH_CNNUMBER'), align: 'center', width: '180px', class: 'text-nowrap ' },
        { id: 'patientFullName', disablePadding: false, label: t('INSTALLMENT.TABLE.PATIENT_NAME'), align: 'left', class: 'text-nowrap ' },
        { id: 'installmentPaidDate', disablePadding: false, label: t('INSTALLMENT.TABLE.INSTALLMENT_PAID_DATE'), align: 'center', width: '160px', class: 'text-nowrap ' },
        { id: 'totalPaid', disablePadding: false, label: t('INSTALLMENT.TABLE.TOTAL_PAID'), align: 'right', width: '180px', class: 'text-nowrap ' },
        { id: 'action', disablePadding: false, label: 'Action', width: '80px', class: 'text-nowrap ' }
    ]

    const renderDataInstallment = (objData: any, index: number) => {
        index = page * pageLimit - pageLimit + index + 1

        const { installmentPaymentId, patientFullName, branchCnNumber, cnNumber, installmentPaidDate, totalPaid, patientId } = objData

        const objRenderData = {
            key: installmentPaymentId,
            id: installmentPaymentId,
            obj: objData,
            columns: [
                { option: 'TEXT', align: 'center', label: index, class: 'text-nowrap ' },
                { option: 'TEXT', align: 'center', label: cnNumber || '-', class: 'text-nowrap ' },
                { option: 'TEXT', align: 'center', label: branchCnNumber || '-', class: 'text-nowrap ' },
                { option: 'TEXT', align: 'left', label: patientFullName || '-', class: 'text-nowrap ' },
                { option: 'TEXT', align: 'center', label: installmentPaidDate ? dateToView(installmentPaidDate) : '-', class: 'text-nowrap ' },
                { option: 'TEXT', align: 'right', label: numberFormat(totalPaid) || '0', class: 'text-nowrap ' },
                {
                    option: 'COMPONENT',
                    component: (
                        <Box textAlign={'center'}>
                            <IconButton
                                sx={{ border: `1px solid ${colors.themeSecondColor}`, borderRadius: '4px', padding: '8px' }}
                                onClick={() => onViewInstallment(patientId)}
                            >
                                <VisibilityIcon sx={{ color: colors.themeSecondColor }} />
                            </IconButton>
                        </Box>
                    )
                },
            ]
        }

        return (<TableRowCommon {...objRenderData} />)
    }

    return (
        <Box>
            <Loading show={loading} />
            <Box width="100%" height="80px" boxShadow="0px 3px 6px 0px #0000001F" border="1px solid #E5E5E5" paddingLeft="24px" display="flex" alignItems="center" fontSize="20px" fontWeight={500} alignContent={'center'}  >
                {t('INSTALLMENT.TITLE')}
            </Box>
            <Box paddingX="24px" paddingTop="16px">
                <Grid container spacing={2}>
                    <Grid item xs={12} sm={6} md={3} xl={2}>
                        <TextInput
                            onChange={(event) => {
                                setSearch(event.target.value);
                            }}
                            label={t('INSTALLMENT.SEARCH')}
                            value={search}
                            size='large'
                            fullWidth={true}
                            inputProps={{
                                value: search,
                                endAdornment: (
                                    <InputAdornment position="end" >
                                        {!search ? <FontAwesomeIcon icon={faSearch} style={{ color: 'rgba(0, 0, 0, 0.6)', fontSize: 15 }} /> :
                                            <FontAwesomeIcon
                                                icon={faTimes}
                                                onClick={() => {
                                                    setSearch('');
                                                }}
                                                style={{ color: 'rgba(0, 0, 0, 0.6)', fontSize: 17, cursor: 'pointer' }} />}
                                    </InputAdornment>
                                ),
                            }}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6} md={3} xl={2}>
                        <DateRangeInput
                            inputHeight={40}
                            value={rangeDate || ['', '']}
                            onchange={(val: any) => {
                                if (_.isEmpty(val)) setRangeDate(['', ''])
                                else setRangeDate([moment(val[0]).format('YYYY-MM-DD'), moment(val[1]).format('YYYY-MM-DD')])
                            }}
                            label={''}
                            allowClear
                            onClear={() => setRangeDate(['', ''])}
                        />
                    </Grid>
                    <Grid item xs={12} md={1} xl={1}>
                        <MainButton
                            title={t('INSTALLMENT.BUTTON.SEARCH')}
                            onClick={() => {
                                setPage(1)
                                loadDataInstallment()
                            }}
                            type="primary"
                            variant="contained"
                            style={{ height: '40px', width: '100px' }}
                        />
                    </Grid>
                </Grid>
                <Box marginTop="24px">
                    <TableCustom
                        page={page}
                        pageLimit={pageLimit}
                        sortType={sortType}
                        sortBy={sortBy}
                        onSort={(sortByVal: string, sortTypeVal: string) => {
                            setSortType(sortTypeVal)
                            setSortBy(sortByVal)
                        }}
                        setPageLimit={(e) => setPageLimit(e)}
                        setPage={(e) => setPage(e)}
                        rowCount={rowCount}
                        headCells={headCells}
                        rowsData={dataInstallment?.length ? dataInstallment.map((item: any, index: number) => renderDataInstallment(item, index)) : []}
                    />
                </Box>
            </Box>
        </Box>
    )
}

export default Installment